module.exports = __webpack_public_path__ + "static/media/form-leaf.84696399.svg";